import { useEffect, useState } from "react";
import { Box, Chip, CircularProgress, Option, Select, Typography } from "@mui/joy";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { APIAdminGetSetting, APIAdminUpdateSetting } from "../../api_admin_settings";

const MODES = [
  { value: "off",      label: "Выкл" },
  { value: "advisor",  label: "Подсказка" },
  { value: "enforcer", label: "Строгий" },
];

/** Тумблер режима ИИ-модерации.
 * props: token, settingKey, description, title */
export default function AiModerationModeToggle({ token, settingKey, description = "", title = "Режим ИИ-модерации" }) {
  const [mode, setMode] = useState(null);   // null = загрузка
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const s = await APIAdminGetSetting(token, settingKey);
        if (alive) setMode(s?.value || "advisor");   // дефолт advisor, если ключа ещё нет
      } catch { if (alive) setMode("advisor"); }
    })();
    return () => { alive = false; };
  }, [token, settingKey]);

  const onChange = async (_, value) => {
    if (!value || value === mode) return;
    const prev = mode;
    setMode(value); setSaving(true);
    try {
      await APIAdminUpdateSetting(token, settingKey, value, description || undefined);
    } catch {
      setMode(prev);   // откат при ошибке (например, нет прав)
    } finally { setSaving(false); }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <AutoAwesomeRoundedIcon color="primary" fontSize="small" />
      <Typography level="body-sm" sx={{ fontWeight: 700 }}>{title}</Typography>
      {mode === null ? (
        <CircularProgress size="sm" />
      ) : (
        <>
          <Select size="sm" value={mode} onChange={onChange} sx={{ minWidth: 150 }} disabled={saving}>
            {MODES.map((m) => <Option key={m.value} value={m.value}>{m.label}</Option>)}
          </Select>
          {mode === "enforcer" && <Chip size="sm" color="danger" variant="soft">автодействия вкл</Chip>}
        </>
      )}
    </Box>
  );
}